import { createSelector } from '@reduxjs/toolkit';
import { selectSuburbanBathroom } from 'shared/selectors/jsonQuery';
import { selectSuburbanBathroomOptions } from './selectSuburbanBathroomOptions';

export const selectSuburbanBathroomFilter = createSelector(
  [selectSuburbanBathroom, selectSuburbanBathroomOptions],
  (value, options) => ({
    label: 'Санузел',
    value: [value],
    options,
  }),
);
